import React, { useState, useEffect, useContext, useMemo } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Button } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import MyContext from "../../MyContext";
import rightArrow from "../../images/Arrow - Right.svg";
import downArrow from "../../images/Arrow - Down.svg";
import AddPrinterModal from "./Catalogue Components/AddPrinterModal";
const OrderSettings = ({ userID }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("deliveryCharges");
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [chargesData, setChargesData] = useState([]);
  const [settlementData, setSettlementData] = useState([]);
  const [discountsData, setDiscountsData] = useState([]);
  const [couponData, setCouponData] = useState([]);
  const [loyaltyPointsData, setLoyaltyPointsData] = useState([]);
  const [timingData, setTimingData] = useState([]);
  const [selectedFreeItem, setSelectedFreeItem] = useState("");
  const [addPrinterModalOpen, setAddPrinterModalOpen] = useState(false);
  const [addPrinterFormData, setAddPrinterFormData] = useState({
    printerName: "",
    printerAlias: "",
    deviceName: "",
    deviceNumber: "",
  });
  const [printerList, setPrinterList] = useState([]);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [deliveryData, setDeliveryData] = useState({
    userid: "",
    charges: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
  });

  // Discount Payload
  const [discountData, setDiscountData] = useState({
    userid: "",
    discount: "",
    fromAmount: "",
    toAmount: "",
    discountType: "",
    orderType: "",
    maxDiscount: "",
  });

  const [newCouponData, setNewCouponData] = useState({
    couponCode: "",
    discount: "",
    discountType: "",
    minOrderAmount: "",
    maxDiscountAmount: "",
    couponTitle: "",
    couponDiscription: "",
  });
  const [updateLoyaltyPointsData, setUpdateLoyaltyPointsData] = useState({
    points: "",
    value: "",
  });
  const [freeItemData, setFreeItemData] = useState({
    minAmount: "",
    singleUse: "",
  });


  const [updateOrderTimingData, setUpdateOrderTimingData] = useState({
    opening: "",
    closing: "",
    weekOff: "",
  });
  const [printSettingData, setPrintSettingData] = useState({
    normalFontSize: "",
    largeFontSize: "",
    pageWidth: "",
    anlookActive: false,
    autoPrint: false
  });
  const [selectedSetting, setSelectedSetting] = useState("1"); // default 1
const [PrintSettingLoading, setPrintSettingLoading] = useState(false);
  const BOOLEAN_01_KEYS = ["anlookActive", "autoPrint"];
  const BOOLEAN_YN_KEYS = ["printEnabled", "kotEnabled"];
  const NUMERIC_KEYS = ["printReceiptCount", "printKotCount"];
  const [printSettingDetails, setPrintSettingDetails] = useState(null); // keep name (your UI expects this)
  const [printConfigs, setPrintConfigs] = useState([]); // array of {key,value}
  const [printForm, setPrintForm] = useState({}); // key -> edited value (string)
  const [printTypeHint, setPrintTypeHint] = useState({}); // key -> "01" | "YN" | "TEXT"
  const [printLoading, setPrintLoading] = useState(false);
  const is01 = (v) => v === "0" || v === "1";
  const isYN = (v) => v === "Y" || v === "N";
  const isNumericString = (v) => typeof v === "string" && v.trim() !== "" && !isNaN(v);
  const toBool = (v) => v === "1" || v === "Y" || v === true;
  const boolToValue = (bool, hint) => {
    if (hint === "YN") return bool ? "Y" : "N";
    return bool ? "1" : "0"; // default "01"
  };
  const normalizePrintConfigurations = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((x) => x && typeof x.key === "string")
      .map((x) => ({
        key: String(x.key),
        value: x.value === null || x.value === undefined ? "" : String(x.value),
      }));
  };

  const buildTypeHints = (configs) => {
    const hints = {};

    configs.forEach((s) => {
      if (BOOLEAN_01_KEYS.includes(s.key)) {
        hints[s.key] = "01";        // switch
      } else if (BOOLEAN_YN_KEYS.includes(s.key)) {
        hints[s.key] = "YN";        // switch
      } else if (NUMERIC_KEYS.includes(s.key)) {
        hints[s.key] = "NUMBER";    // numeric input
      } else {
        hints[s.key] = "TEXT";      // normal input
      }
    });

    return hints;
  };


  const configsToForm = (configs) => {
    const obj = {};
    configs.forEach((s) => (obj[s.key] = s.value));
    return obj;
  };
  const getPrintSettingsApi = async () => {
    if (!userID) return;

    setPrintLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPrintSettings`,
        { userid: userID },
        config
      );

      if (response?.data?.responseCode === "00") {
        const raw = response?.data?.response?.[0]?.printConfigurations || [];
        const normalized = normalizePrintConfigurations(raw);

        setPrintConfigs(normalized);
        setPrintTypeHint(buildTypeHints(normalized));
        setPrintForm(configsToForm(normalized));

        // keep your current "details" style so left card still works
        setPrintSettingDetails({
          printSettings: normalized, // same name you use in UI
        });
      } else {
        setPrintConfigs([]);
        setPrintForm({});
        setPrintSettingDetails(null);
        toast.error(response?.data?.responseMessage || "Failed to fetch print settings.");
      }
    } catch (error) {
      setPrintConfigs([]);
      setPrintForm({});
      setPrintSettingDetails(null);
      toast.error("Error fetching print settings.");
    } finally {
      setPrintLoading(false);
    }
  };

  // --- dynamic input change
  const handlePrintDynamicChange = (key, nextValue) => {
    setPrintForm((prev) => ({
      ...prev,
      [key]: nextValue,
    }));
  };

  // --- API: UPDATE print settings (NEW)
  // IMPORTANT: always sends ALL keys, not only changed ones
  const handleUpdatePrintSetting = async () => {
    if (!userID) {
      toast.error("User ID missing.");
      return;
    }

    if (!printConfigs || printConfigs.length === 0) {
      toast.error("No print settings loaded.");
      return;
    }

    /* ---------------- VALIDATION ---------------- */

    // ✅ Validate numeric count fields ONLY
    for (const key of NUMERIC_KEYS) {
      const value = printForm[key];

      if (value !== undefined) {
        if (value === "" || isNaN(value)) {
          toast.error(`${key} must be a numeric value`);
          return;
        }
      }
    }

    /* ---------------- BUILD PAYLOAD ---------------- */

    const payload = {
      userid: userID,
      printsetting: printConfigs.map((s) => {
        let finalValue = printForm[s.key];

        // fallback to old value if unchanged
        if (finalValue === undefined || finalValue === null) {
          finalValue = s.value;
        }

        // normalize boolean fields
        if (BOOLEAN_01_KEYS.includes(s.key)) {
          finalValue = finalValue === "1" || finalValue === 1 || finalValue === true ? "1" : "0";
        }

        if (BOOLEAN_YN_KEYS.includes(s.key)) {
          finalValue = finalValue === "Y" || finalValue === true ? "Y" : "N";
        }

        // numeric counts → string
        if (NUMERIC_KEYS.includes(s.key)) {
          finalValue = String(finalValue);
        }

        return {
          key: s.key,
          value: String(finalValue),
        };
      }),
    };

    /* ---------------- API CALL ---------------- */

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updatePrintSetting`,
        payload,
        config
      );

      if (response?.data?.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Print settings updated successfully."
        );
        getPrintSettingsApi(); // refresh latest values
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to update print settings."
        );
      }
    } catch (error) {
      toast.error("Error occurred while updating print settings.");
    } finally {
      setLoading(false);
    }
  };


  // ✅ call GET on load (replaces your old receipt useEffects)
  useEffect(() => {
    getPrintSettingsApi();
  }, [userID]);
  const [serviceData, setServiceData] = useState([]);
  const isEmptyOrWhitespace = (value) => !value || !value.trim();
  const isNumber = (value) => !isNaN(value) && value.trim() !== "";
  const handleDeliveryChange = (e) => {
    setDeliveryData({ ...deliveryData, [e.target.name]: e.target.value });
  };
  const handlePrintSettingChange = (e) => {
    const { name, type, value, checked } = e.target;
    setPrintSettingData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDiscountChange = (e) => {
    setDiscountData({ ...discountData, [e.target.name]: e.target.value });
  };
  const handleNewCouponChange = (e) => {
    setNewCouponData({ ...newCouponData, [e.target.name]: e.target.value });
  };
  const handleUpdateDeliveryCharges = async () => {
    const { charges, fromAmount, toAmount, chargeType } = deliveryData;

    if (
      isEmptyOrWhitespace(userID) ||
      isEmptyOrWhitespace(charges) ||
      !isNumber(charges) ||
      isEmptyOrWhitespace(fromAmount) ||
      !isNumber(fromAmount) ||
      isEmptyOrWhitespace(toAmount) ||
      !isNumber(toAmount) ||
      isEmptyOrWhitespace(chargeType)
    ) {
      toast.error(
        " Please fill all fields correctly. Charges and Amounts must be numeric."
      );
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID.trim(),
        charges: charges.trim(),
        fromAmount: fromAmount.trim(),
        toAmount: toAmount.trim(),
        chargeType: chargeType.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateDeliveryCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          ` ${response?.data?.responseMessage ||
          "Delivery charges updated successfully."
          }`
        );

        // Reset deliveryData
        setDeliveryData({
          userid: "",
          charges: "",
          fromAmount: "",
          toAmount: "",
          chargeType: "",
        });
        getChargesApi();
      } else {
        toast.error(
          ` ${response?.data?.responseMessage ||
          "Failed to update delivery charges."
          }`
        );
      }
    } catch (error) {
      // toast.error(" Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleOrderTimingChange = (e) => {
    setUpdateOrderTimingData({
      ...updateOrderTimingData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateDiscount = async () => {
    const {
      discount,
      fromAmount,
      toAmount,
      discountType,
      orderType,
      maxDiscount,
    } = discountData;

    if (
      isEmptyOrWhitespace(userID) ||
      isEmptyOrWhitespace(discount) ||
      !isNumber(discount) ||
      isEmptyOrWhitespace(fromAmount) ||
      !isNumber(fromAmount) ||
      isEmptyOrWhitespace(toAmount) ||
      !isNumber(toAmount) ||
      isEmptyOrWhitespace(discountType) ||
      isEmptyOrWhitespace(orderType)
    ) {
      toast.error(
        " Please fill all fields correctly. Discount and Amounts must be numeric."
      );
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID.trim(),
        discount: discount.trim(),
        fromAmount: fromAmount.trim(),
        toAmount: toAmount.trim(),
        discountType: discountType.trim(),
        orderType: orderType.trim(),
        maxDiscount: maxDiscount.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          ` ${response?.data?.responseMessage || "Discount updated successfully."
          }`
        );

        // Reset discountData
        setNewCouponData({
          couponCode: "",
          discount: "",
          discountType: "",
          minOrderAmount: "",
          maxDiscountAmount: "",
          couponTitle: "",
          couponDiscription: "",
        });
        // getChargesApi();
      } else {
        toast.error(
          ` ${response?.data?.responseMessage || "Failed to update discount."}`
        );
      }
    } catch (error) {
      toast.error("Error updating discount. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleLoyaltyPointsChange = (e) => {
    setUpdateLoyaltyPointsData({
      ...updateLoyaltyPointsData,
      [e.target.name]: e.target.value,
    });
  };
  const handleFreeItemChanges = (e) => {
    setFreeItemData({ ...freeItemData, [e.target.name]: e.target.value });
  };




  const handleUpdateOrderTiming = async () => {
    const { opening, closing, weekOff } = updateOrderTimingData;

    if (!opening || !closing || !weekOff) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        opening,
        closing,
        weekOff,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateRestaurantTiming`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage ||
          "Order timing updated successfully."
        );
        setUpdateOrderTimingData({ opening: "", closing: "", weekOff: "" });
        // Optionally refetch updated timing info here
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to update order timing."
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateLoyaltyPoints = async () => {
    const { points, value } = updateLoyaltyPointsData;

    if (!isNumber(points) || !isNumber(value)) {
      toast.error("Please enter valid numeric values for both fields.");
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        userid: userID,
        points: Number(points),
        value: Number(value),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateMerchantLoyaltyPointsConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage ||
          "Loyalty points updated successfully."
        );

        // Optional: Reset form if needed
        setUpdateLoyaltyPointsData({ points: "", value: "" });

        getLoyaltyPointsApi();
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to update loyalty points."
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  const [serviceloading, setServiceLoading] = useState(false);

  // Fetch services from API
  const getServicesApi = async () => {
    setServiceLoading(true);
    try {
      const requestBody = { userid: userID };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderTypeOptions`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setServiceData(response.data.response);
      } else {
        toast.error("Failed to load services.");
      }
    } catch (error) {
      toast.error("Error fetching services.");
    } finally {
      setServiceLoading(false);
    }
  };

  // Toggle service ON/OFF
  const handleUpdateServicesAPI = async (orderType, currentStatus) => {
    setServiceLoading(true);
    try {
      const requestBody = {
        userid: userID,
        orderType: orderType,
        status: currentStatus === "Y" ? "N" : "Y",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateOrderTypeOptions`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success("Service status updated successfully.");
        getServicesApi(); // Refresh list
      } else {
        toast.error("Failed to update service status.");
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setServiceLoading(false);
    }
  };

  const reciptDetailsApi = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
        userid: userID,
      }, config);

      if (response.data.responseCode === "00") {
        const data = response.data.response[0];

        // ✅ Parse printSettings JSON safely
        let parsedSettings = [];
        if (data.printSettings) {
          try {
            parsedSettings =
              typeof data.printSettings === "string"
                ? JSON.parse(data.printSettings)
                : data.printSettings;
          } catch (error) {
            console.error("Failed to parse printSettings:", error);
          }
        }

        // ✅ Extract each value safely
        const getValue = (key) =>
          parsedSettings.find((s) => s.key === key)?.value || "";

        // ✅ Update both display and editable states
        setPrintSettingDetails({
          autoPrint: data.autoPrint,
          printOn: data.printOn,
          printOption: data.printOption,
          printSettings: parsedSettings,
        });

        setPrintSettingData({
          normalFontSize: getValue("normalFontSize"),
          largeFontSize: getValue("largeFontSize"),
          pageWidth: getValue("pageWidth"),
          anlookActive: getValue("anlookActive") === "1",
          autoPrint: getValue("autoPrint") === "1",
        });
      } else {
        console.error("Failed to fetch print settings:", response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching print settings:", error);
    }
  };

  useEffect(() => {
    reciptDetailsApi();
  }, []);


  useEffect(() => {
    reciptDetailsApi();
    // fetchOrganizationDetails();
  }, []);
  useEffect(() => {
    if (printSettingDetails?.printSettings && typeof printSettingDetails.printSettings === "string") {
      try {
        const parsedSettings = JSON.parse(printSettingDetails.printSettings);
        setPrintSettingDetails(prev => ({
          ...prev,
          printSettings: parsedSettings,
        }));
      } catch (err) {
        console.error("Failed to parse printSettings:", err);
      }
    }
  }, [printSettingDetails]);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);

  const handleSetFreeItems = async () => {
    setAttemptedSubmit(true);
    const { minAmount, singleUse } = freeItemData;

    if (!isNumber(minAmount)) {
      toast.error("Please enter a valid amount and select a free item.");
      return;
    }
    if (!singleUse) {
      toast.error("Please select customer type.");
      return;
    }
    if (!selectedFreeItem) {
      toast.error("Please select a free item.");
      return;
    }

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        minAmount,
        singleUse,
        item: selectedFreeItem,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/addFreeItems`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Free item set successfully."
        );
        getLoyaltyPointsApi();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to set free item."
        );
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleCreateNewCoupon = async () => {
    const {
      couponCode,
      discount,
      discountType,
      minOrderAmount,
      maxDiscountAmount,
      couponTitle,
      couponDiscription,
    } = newCouponData;

    if (
      isEmptyOrWhitespace(couponCode) ||
      !isNumber(discount) ||
      isEmptyOrWhitespace(discountType) ||
      !isNumber(minOrderAmount) ||
      !isNumber(maxDiscountAmount) ||
      isEmptyOrWhitespace(couponTitle) ||
      isEmptyOrWhitespace(couponDiscription)
    ) {
      toast.error(
        "Please fill all fields correctly. Discount and amounts must be numeric."
      );
      return;
    }

    setLoading(true);

    try {
      const requestBody = {
        userid: userID,
        couponCode: couponCode.trim(),
        discount: Number(discount),
        discountType: discountType.trim(),
        minOrderAmount: Number(minOrderAmount),
        maxDiscountAmount: Number(maxDiscountAmount),
        couponTitle: couponTitle.trim(),
        couponDiscription: couponDiscription.trim(),
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/createMerchantCouponCode`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Coupon created successfully"
        );

        // Reset form
        setNewCouponData({
          couponCode: "",
          discount: "",
          discountType: "",
          minOrderAmount: "",
          maxDiscountAmount: "",
          couponTitle: "",
          couponDiscription: "",
        });

        getCouponApi();
      } else {
        toast.error(
          response?.data?.responseMessage || "Failed to create coupon"
        );
      }
    } catch (error) {
      toast.error("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getLoyaltyPointsApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantLoyaltyPointsConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setLoyaltyPointsData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const getTimingApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getRestaurantTiming`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setTimingData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getCouponApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantCouponCodes`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setCouponData(response.data.data);
      } else {
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getChargesApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getDeliveryChargesAndDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const { charges, discount } = response.data.data;

        // Update delivery charges and discounts from API response
        setChargesData(charges);
        setDiscountsData(discount);

        // toast.success(
        //   `${
        //     response?.data?.responseMessage ||
        //     "Delivery charges updated successfully."
        //   }`
        // );
      } else {
        // toast.error(
        //   `${
        //     response?.data?.responseMessage ||
        //     "Failed to update delivery charges."
        //   }`
        // );
      }
    } catch (error) {
      toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getSettlementApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getSettlementConfig`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const { charges, discount } = response.data.data;

        // Update delivery charges and discounts from API response
        setChargesData(charges);
        setDiscountsData(discount);
      } else {
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDiscount = async (discountId) => {
    try {
      const requestBody = {
        userid: userID,
        discountId: discountId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDiscount`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getChargesApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };
  const handleDeleteDeliveryCharges = async (chargeId) => {
    try {
      const requestBody = {
        userid: userID,
        chargeId: chargeId,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDeliveryCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getChargesApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };
  const handleDeleteCoupon = async (couponId) => {
    try {
      const requestBody = {
        userid: userID,
        couponId: couponId,
        operation: "DELETE",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/disableMerchantCouponCode`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response?.data?.responseMessage);

        getCouponApi();
      } else {
        toast.error(`${response?.data?.responseMessage || "Failed to remove"}`);
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    }
  };

  const [orderCharges, setOrderCharges] = useState([]);
  const getOrderChargesApi = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setOrderCharges(response.data.response);
      } else {
      }
    } catch (error) {
      // toast.error("Error updating delivery charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // new Order Chagrge Payload
  const [newOrderCharge, setNewOrderCharge] = useState({
    userid: "",
    discount: "",
    fromAmount: "",
    toAmount: "",
    chargeType: "",
    chargeOn: "",
  });
  const handleOrderChargeChange = (e) => {
    const { name, value } = e.target;
    setNewOrderCharge((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleUpdateOrderCharges = async () => {
    const { userid, charges, fromAmount, toAmount, chargeType } =
      newOrderCharge;
    if (isEmptyOrWhitespace(chargeType)) {
      toast.error(
        "Please fill all fields correctly. Charges and Amounts must be numeric."
      );
      return;
    }
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        charges: "",
        fromAmount: "",
        toAmount: "",
        chargeType: "",
        chargeOn: chargeType, // or any appropriate static/dynamic value
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateOrderCharges`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Order charges updated successfully."
        );
        // Reset form
        setNewOrderCharge({
          userid: userID,
          charges: "",
          fromAmount: "",
          toAmount: "",
          chargeType: "",
        });
        getOrderChargesApi();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update charges."
        );
      }
    } catch (error) {
      toast.error("Error updating charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getChargesApi();
    getOrderChargesApi();
    getSettlementApi();
    getCouponApi();
    getLoyaltyPointsApi();
    getTimingApi();
    getServicesApi();
  }, []);
  // -----------------------------
  // Packaging Charges & Triggers
  // -----------------------------
  const [packagingForm, setPackagingForm] = useState({
    pk_info_id: "",
    organization_name: "",
    packagingOrderTrigger: "N", // Y/N
    packagingOrderCharges: "",  // string (number)
    itemTrigger: "N",           // Y/N
    itemCharges: "",            // string (number)
  });

  const getPackagingChargesAndTriggersApi = async () => {
    try {
      const requestBody = { userid: userID };
      const resp = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPackagingChargesAndTriggers`,
        requestBody,
        config
      );

      if (resp?.data?.responseCode === "00") {
        const row = (resp?.data?.response || [])?.[0] || {};
        setPackagingForm({
          pk_info_id: row.pk_info_id || "",
          organization_name: row.organization_name || "",
          packagingOrderTrigger: row.packagingOrderWise || "N",
          packagingOrderCharges:
            row.packagingOrderWiseCharges === null ||
              row.packagingOrderWiseCharges === undefined
              ? ""
              : String(row.packagingOrderWiseCharges),
          itemTrigger: row.packagingItemWise || "N",
          itemCharges:
            row.packagingItemCharges === null ||
              row.packagingItemCharges === undefined
              ? ""
              : String(row.packagingItemCharges),
        });
      }
    } catch (e) {
      // silent; keep UI usable
    }
  };

  const onPackagingToggle = (key) => (e) => {
    const next = e.target.checked ? "Y" : "N";

    setPackagingForm((p) => {
      // If turning ON order-wise, force item-wise OFF
      if (key === "packagingOrderTrigger" && next === "Y") {
        return {
          ...p,
          packagingOrderTrigger: "Y",
          itemTrigger: "N",
          itemCharges: "",
        };
      }

      // If turning ON item-wise, force order-wise OFF
      if (key === "itemTrigger" && next === "Y") {
        return {
          ...p,
          itemTrigger: "Y",
          packagingOrderTrigger: "N",
          packagingOrderCharges: "",
        };
      }

      // Turning OFF (either one)
      if (key === "packagingOrderTrigger" && next === "N") {
        return { ...p, packagingOrderTrigger: "N", packagingOrderCharges: "" };
      }
      if (key === "itemTrigger" && next === "N") {
        return { ...p, itemTrigger: "N", itemCharges: "" };
      }

      return { ...p, [key]: next };
    });
  };


  const onPackagingChargeChange = (key) => (e) => {
    const value = e.target.value;
    // allow empty + digits + decimal
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setPackagingForm((p) => ({ ...p, [key]: value }));
    }
  };

  const handleUpdatePackagingChargesAndTriggers = async () => {
    // validations
    if (
      packagingForm.packagingOrderTrigger === "Y" &&
      !isNumber(String(packagingForm.packagingOrderCharges || ""))
    ) {
      return toast.error("Enter valid Order-wise packaging charge.");
    }
    if (
      packagingForm.itemTrigger === "Y" &&
      !isNumber(String(packagingForm.itemCharges || ""))
    ) {
      return toast.error("Enter valid Item-wise packaging charge.");
    }

    const confirm = await Swal.fire({
      title: "Update Packaging Settings?",
      text: "This will change packaging charges/triggers for orders/items.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const orderOn = packagingForm.packagingOrderTrigger === "Y";
      const itemOn = packagingForm.itemTrigger === "Y";

      // extra safety: if somehow both became Y, prefer the one user last toggled in UI (but our UI prevents it).
      // Here we enforce "only one"
      const finalOrderTrigger = orderOn ? "Y" : "N";
      const finalItemTrigger = orderOn ? "N" : itemOn ? "Y" : "N";

      const requestBody = {
        userid: userID,

        packagingOrderTrigger: finalOrderTrigger,
        packagingOrderCharges:
          finalOrderTrigger === "Y"
            ? String(packagingForm.packagingOrderCharges || "0")
            : "0",

        itemTrigger: finalItemTrigger,
        itemCharges:
          finalItemTrigger === "Y"
            ? String(packagingForm.itemCharges || "0")
            : "0",
      };


      const resp = await axios.post(
        `${baseUrl}/api/Order/v1.0/UpdatePackagingChargesAndTriggers`,
        requestBody,
        config
      );

      if (resp?.data?.responseCode === "00") {
        toast.success("Packaging settings updated successfully.");
        getPackagingChargesAndTriggersApi();
      } else {
        toast.error(resp?.data?.responseMessage || "Failed to update.");
      }
    } catch (e) {
      toast.error("Error updating packaging settings.");
    } finally {
      setLoading(false);
    }
  };

  const [catalogueStore, setCatalogueStore] = useState([]);
  const allcatalogueAPI = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getMerchantMenuItems`,
        requestBody,
        config
      );
      console.log(response.data.response);
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allcatalogueAPI();
    getPackagingChargesAndTriggersApi();
  }, []);
  const toggleCategory = (catId) => {
    setExpandedCategories((prev) =>
      prev.includes(catId)
        ? prev.filter((id) => id !== catId)
        : [...prev, catId]
    );
  };
  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) =>
          item?.item_name?.toLowerCase().includes(searchText.toLowerCase())
        );
        return {
          ...category,
          menu_items: filteredItems, // make sure to keep it as `menu_items` so your component works
        };
      })
      .filter((category) => category.menu_items.length > 0); // remove empty categories
  }, [catalogueStore, searchText]);
  useEffect(() => {
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
    } else {
      // Optional: collapse all
      const firstCatId = String(catalogueStore?.[0]?.cat_id || "");
      setExpandedCategories(firstCatId ? [firstCatId] : []);
    }
  }, [filteredCategories, searchText, catalogueStore]);
  const handlePrinterInputChange = (e) => {
    setAddPrinterFormData({
      ...addPrinterFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddPrinterSubmit = async () => {
    const payload = {
      userid: String(userID),
      ...addPrinterFormData,
    };

    try {
      const res = await fetch(`${baseUrl}/api/Order/v1.0/addPrinter`, {
        method: "POST",
        headers: {
          ...config.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.responseCode === "00") {
        Swal.fire("Success", data.responseMessage, "success");
        setAddPrinterModalOpen(false);
        setAddPrinterFormData({
          printerName: "",
          printerAlias: "",
          deviceName: "",
          deviceNumber: "",
        });
      } else {
        Swal.fire("Error", data.responseMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const fetchPrinterList = async () => {
    try {
      setPrinterLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPrinters`,
        {
          userid: userID,
        },
        config
      );

      if (res.data.responseCode === "00") {
        setPrinterList(res.data.response || []);
      } else {
        toast.error("Failed to load printers");
      }
    } catch (err) {
      // toast.error("Error fetching printers");
    } finally {
      setPrinterLoading(false);
    }
  };
  useEffect(() => {
    fetchPrinterList()
  }, [])
const getPrinterSetting = async () => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/Order/getPrinterSettingAbhi`,
      { userid: userID },
      config
    );

    if (
      response.data.responseCode === "00" &&
      response.data.response.length > 0
    ) {
      const savedSetting = response.data.response[0].setting_type;
      setSelectedSetting(savedSetting);
    }
  } catch (error) {
    console.error("Error fetching printer setting:", error);
  }
};
useEffect(() => {
  getPrinterSetting();
}, []);
const savePrinterSetting = async () => {
  try {
    setLoading(true);

    const response = await axios.post(
      `${baseUrl}/api/Order/v1.0/AddPrintSettingAbhi`,
      {
        userid: userID,
        settings: selectedSetting, // 1 / 2 / 3
      },
      config
    );

    if (response.data.responseCode === "00") {
      toast.success("Printer setting saved successfully");
    } else {
      toast.error("Failed to save printer setting");
    }
  } catch (error) {
    console.error("Save error:", error);
    toast.error("Something went wrong");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div>
        <div
          className="p-4 bg-white"
          style={{
            height: "100vh",
            fontFamily: "Nunito,sans-serif",
          }}
        >
          <div className="px-4 justify-content-center">
            <Form className="d-flex justify-content-between pb-4">
              <Form.Label className="CreateCampaign">Order Settings</Form.Label>
            </Form>
            {/* Tab Headers */}
            <ul className="nav nav-tabs mb-4 bg-light p-2 rounded shadow-sm">
              {[
                { key: "deliveryCharges", label: "Delivery Charges" },
                { key: "services", label: "Services" },

                { key: "discounts", label: "Discounts" },
                { key: "coupon", label: "Coupon" },
                { key: "loyaltyPoints", label: "Loyalty Points" },
                { key: "free", label: "Free Items" },
                { key: "orderCharges", label: "Order Charges" },
                { key: "orderTiming", label: "Order Timing" },
                { key: "printing", label: "Receipt Printing" },
              ].map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    className={`nav-link fw-semibold rounded-top px-3 py-2 mx-1 ${activeTab === tab.key
                      ? "active order-section-button bg-green-order  text-white"
                      : "text-dark bg-light"
                      }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
            {/* Tab Contents */}
            {loading ? (
              <div className="m-5 p-5 d-flex justify-content-center">
                <div className="loader"></div>
              </div>
            ) : (
              <>
                {/* Order Charges Tab */}
                {activeTab === "orderCharges" && (
                  <div className="row col-12 m-0 p-0">
                    <div className="col-8 h-100 mb-3">
                      {orderCharges.map((charge, index) => (
                        <div key={index} className="col h-100">
                          <div className="p-4 bg-white w-100 h-100  border rounded-4 mb-3">
                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                              <h5 className="fw-semibold text-success ">
                                Currently Applied Order Charges
                              </h5>
                            </div>

                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Charges: </span>
                                <span className="fw-medium text-dark">
                                  {charge.charge_type === "F" ? "₹" : ""}
                                  {parseFloat(charge.charges).toFixed(2)}
                                  {charge.charge_type === "F" ? "" : "%"}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span className="text-muted">From:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.from_amount).toFixed(2)}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span className="text-muted">To:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.to_amount).toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* ✅ NEW: Packaging Charges Card */}
                    <div className="col-4 mb-3">
                      <div className="p-4 bg-light border-0 rounded-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="fw-semibold text-success m-0">Packaging Charges</h5>
                          <span className="badge text-bg-success-subtle border border-success-subtle text-success">
                            {packagingForm.organization_name || "Organization"}
                          </span>
                        </div>

                        {/* Order-wise */}
                        <div className="border-top pt-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <div className="fw-semibold">Order-wise Packaging</div>
                              <div className="small text-muted">Applies once per order</div>
                            </div>
                            <div className="form-check form-switch m-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={packagingForm.packagingOrderTrigger === "Y"}
                                onChange={onPackagingToggle("packagingOrderTrigger")}
                                disabled={packagingForm.itemTrigger === "Y"}   // ✅ add
                              />

                            </div>
                          </div>

                          {packagingForm.packagingOrderTrigger === "Y" && (
                            <div className="mt-2">
                              <label className="form-label mb-1">
                                Order Packaging Charge (₹)
                              </label>
                              <input
                                className="form-control"
                                placeholder="e.g. 10"
                                value={packagingForm.packagingOrderCharges}
                                onChange={onPackagingChargeChange("packagingOrderCharges")}
                              />
                            </div>
                          )}
                        </div>

                        {/* Item-wise */}
                        <div className="border-top pt-3 mt-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <div className="fw-semibold">Item-wise Packaging</div>
                              <div className="small text-muted">Applies on each item</div>
                            </div>
                            <div className="form-check form-switch m-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={packagingForm.itemTrigger === "Y"}
                                onChange={onPackagingToggle("itemTrigger")}
                                disabled={packagingForm.packagingOrderTrigger === "Y"}  // ✅ add
                              />

                            </div>
                          </div>

                          {packagingForm.itemTrigger === "Y" && (
                            <div className="mt-2">
                              <label className="form-label mb-1">Item Packaging Charge (₹)</label>
                              <input
                                className="form-control"
                                placeholder="e.g. 5"
                                value={packagingForm.itemCharges}
                                onChange={onPackagingChargeChange("itemCharges")}
                              />
                            </div>
                          )}
                        </div>

                        <button
                          className="btn btn-success w-100 mt-4"
                          onClick={handleUpdatePackagingChargesAndTriggers}
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Update Packaging Settings"}
                        </button>

                        <div className="small text-muted mt-1">
                          Only one option can be enabled at a time.
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                {/* services Tab */}
                {activeTab === "services" && (
                  <div className="row">
                    <div className="col-12">
                      <div className="p-4 bg-light border-0 rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Activate/Deactivate Services
                        </h5>

                        <div className="row g-4">
                          {serviceData.length === 0 && (
                            <div className="text-danger">No services found.</div>
                          )}
                          {serviceData.map((service) => (
                            <div
                              key={service.id}
                              className="d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm"
                            >
                              <span className="text-dark text-capitalize">
                                {service.orderType.replace("_", " ")}
                              </span>
                              <button
                                className={`btn ${service.status === "Y" ? "btn-danger" : "btn-success"
                                  }`}
                                onClick={() =>
                                  handleUpdateServicesAPI(service.orderType, service.status)
                                }
                                disabled={loading}
                              >
                                {service.status === "Y" ? "Deactivate" : "Activate"}
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Delivery Charges Tab */}
                {activeTab === "deliveryCharges" && (
                  <div className="row">
                    <div className="col-12">
                      {/* Current Delivery Charge Display */}
                      {chargesData.map((charge, index) => (
                        <div key={index} className="col">
                          <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                              <h5 className="fw-semibold text-success ">
                                Currently Applied Delivery Charges
                              </h5>
                              {/* <div>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    handleDeleteDeliveryCharges(charge.id);
                                  }}
                                >
                                  Remove
                                </button>
                              </div> */}
                            </div>
                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Charges:</span>
                                <span className="fw-medium text-dark">
                                  {charge.charge_type === "fixed" ? "₹" : ""}
                                  {parseFloat(charge.charges).toFixed(2)}
                                  {charge.charge_type === "fixed" ? "" : "%"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Type:</span>
                                <span className="fw-medium text-dark">
                                  {charge.charge_type}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">From:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.from_amt).toFixed(2)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">To:</span>
                                <span className="fw-medium text-dark">
                                  ₹{parseFloat(charge.to_amt).toFixed(2)}
                                </span>
                              </div>
                            </div>

                          </div>
                        </div>
                      ))}

                      {/* <div className="p-4 bg-light border-0  rounded-4 mb-5">
                        <h5 className="fw-semibold text-success mb-4">
                          {" "}
                          Update Delivery Charges
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Charges</label>
                            <input
                              type="text"
                              className="form-control"
                              name="charges"
                              value={deliveryData.charges}
                              onChange={handleDeliveryChange}
                              placeholder="Enter Charges"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">From Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="fromAmount"
                              value={deliveryData.fromAmount}
                              onChange={handleDeliveryChange}
                              placeholder="Enter From Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">To Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="toAmount"
                              value={deliveryData.toAmount}
                              onChange={handleDeliveryChange}
                              placeholder="Enter To Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Charge Type</label>
                            <select
                              className="form-control"
                              name="chargeType"
                              value={deliveryData.chargeType}
                              onChange={handleDeliveryChange}
                            >
                              <option value="">Select Charge Type</option>
                              <option value="fixed">Fixed</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4"
                            onClick={handleUpdateDeliveryCharges}
                            disabled={loading}
                          >
                            {loading
                              ? "Updating..."
                              : "Update Delivery Charges"}
                          </button>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}

                {/* Discounts Tab */}
                {activeTab === "discounts" && (
                  <div className="row">
                    <div className="col-12">
                      {/* Current Discount Display */}
                      {discountsData.length > 0 ? (
                        <>
                          {discountsData.map((discount, index) => (
                            <div key={index} className="col">
                              <div className="p-4 bg-white w-100  border rounded-4 mb-3">
                                <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                  <h5 className="fw-semibold text-success ">
                                    Currently Applied Discount
                                  </h5>
                                  <div>
                                    <button
                                      className="btn btn-danger"
                                      onClick={() => {
                                        handleDeleteDiscount(discount.id);
                                      }}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Discount:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {discount.charge_type === "fixed"
                                        ? "₹"
                                        : ""}
                                      {parseFloat(discount.discount).toFixed(2)}
                                      {discount.charge_type === "fixed"
                                        ? ""
                                        : "%"}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Type:</span>
                                    <span className="fw-medium text-dark">
                                      {discount.discount_type}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">From:</span>
                                    <span className="fw-medium text-dark">
                                      ₹
                                      {parseFloat(discount.from_amt).toFixed(2)}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">To:</span>
                                    <span className="fw-medium text-dark">
                                      ₹{parseFloat(discount.to_amt).toFixed(2)}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      {" "}
                                      Maximum Discount Limit
                                    </span>
                                    <span className="fw-medium text-dark">
                                      ₹
                                      {parseFloat(
                                        discount.max_discount
                                      ).toFixed(2)}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Order Type:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {discount.order_type}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="p-4 bg-light border-0  rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Update Discount
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Discount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="discount"
                              value={discountData.discount}
                              onChange={handleDiscountChange}
                              placeholder="Enter Discount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">From Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="fromAmount"
                              value={discountData.fromAmount}
                              onChange={handleDiscountChange}
                              placeholder="Enter From Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">To Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="toAmount"
                              value={discountData.toAmount}
                              onChange={handleDiscountChange}
                              placeholder="Enter To Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Maximum Discount Limit{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="maxDiscount"
                              value={discountData.maxDiscount}
                              onChange={handleDiscountChange}
                              placeholder="Enter Maximum Discount Limit "
                            />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Discount Type</label>
                            <select
                              className="form-control"
                              name="discountType"
                              value={discountData.discountType}
                              onChange={handleDiscountChange}
                            >
                              <option value="">Select Discount Type</option>
                              <option value="fixed">Fixed</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Order Type</label>
                            <select
                              className="form-select"
                              name="orderType"
                              value={discountData.orderType}
                              onChange={handleDiscountChange}
                            >
                              <option value="">Select Order Type</option>
                              <option value="homeDelivery">
                                Home Delivery
                              </option>
                              <option value="takeaway">Takeaway</option>
                              <option value="dining">Dining</option>
                            </select>
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4 "
                            onClick={handleUpdateDiscount}
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Update Discount"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Coupon Tab */}
                {activeTab === "coupon" && (
                  <div className="">
                    <div className="row col-12 p-0 m-0">
                      {/* Current Coupon Display */}
                      {couponData.length > 0 ? (
                        <>
                          {couponData.map((coupon, index) => (
                            <div key={index} className="col-6 p-0 m-0">
                              <div className="p-4 m-2 bg-white  border rounded-4 mb-3">
                                <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                  <h5 className="fw-semibold text-success">
                                    Coupon Code :{" "}
                                    <span className="text-italic text-dark">
                                      {coupon.coupon_code}
                                    </span>
                                  </h5>
                                  <div className="d-flex justify-content-center gap-3">
                                    <button
                                      className="btn btn-warning "
                                      disabled
                                    //  onClick={() => handleDeleteCoupon(coupon.id)}
                                    >
                                      Disable
                                    </button>
                                    <button
                                      className="btn btn-danger"
                                      onClick={() =>
                                        handleDeleteCoupon(coupon.id)
                                      }
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Coupon Code:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {coupon.coupon_code}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Discount:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {coupon.discount_type === "fixed"
                                        ? "₹"
                                        : ""}
                                      {parseFloat(coupon.discount).toFixed(2)}
                                      {coupon.discount_type === "fixed"
                                        ? ""
                                        : "%"}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Discount Type:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {coupon.discount_type}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Minimum Order Amount:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      ₹
                                      {parseFloat(coupon.min_amount).toFixed(2)}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">Title:</span>
                                    <span className="fw-medium text-dark">
                                      {coupon.coupon_title}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <span className="text-muted">
                                      Description:
                                    </span>
                                    <span className="fw-medium text-dark">
                                      {coupon.coupon_description}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-danger mb-4">
                          No coupon found.
                        </div>
                      )}

                      <div className="p-4 bg-light border-0  rounded-4">
                        {/* {JSON.stringify(newCouponData)} */}
                        <h5 className="fw-semibold text-success mb-4">
                          Create New Coupon
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Coupon Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="couponCode"
                              value={newCouponData.couponCode}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Coupon Code"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Discount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="discount"
                              value={newCouponData.discount}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Discount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Min Order Amount
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="minOrderAmount"
                              value={newCouponData.minOrderAmount}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Min Order Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Maximum Discount Amount
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="maxDiscountAmount"
                              value={newCouponData.maxDiscountAmount}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Maximum Discount Amount"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Coupon Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="couponTitle"
                              value={newCouponData.couponTitle}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Coupon Title"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Coupon Discription{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="couponDiscription"
                              value={newCouponData.couponDiscription}
                              onChange={handleNewCouponChange}
                              placeholder="Enter Coupon Discription "
                            />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Discount Type</label>
                            <select
                              className="form-control"
                              name="discountType"
                              value={newCouponData.discountType}
                              onChange={handleNewCouponChange}
                            >
                              <option value="">Select Discount Type</option>
                              <option value="fixed">Fixed</option>
                              <option value="percentage">Percentage</option>
                            </select>
                          </div>
                          {/* <div className="col-md-6">
              <label className="form-label">Order Type</label>
              <select
                className="form-select"
                name="orderType"
                value={discountData.orderType}
                onChange={handleNewCouponChange}
              >
                <option value="">Select Order Type</option>
                <option value="homeDelivery">
                  Home Delivery
                </option>
                <option value="takeaway">Takeaway</option>
                <option value="dining">Dining</option>
              </select>
            </div> */}
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4 "
                            onClick={handleCreateNewCoupon}
                            disabled={loading}
                          >
                            {loading ? "Creating..." : "Create Coupon"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === "loyaltyPoints" && (
                  <div className="row">
                    <div className="col-12">
                      {loyaltyPointsData.length > 0 ? (
                        loyaltyPointsData.map((item, index) => (
                          <div key={index} className="col">
                            <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                              <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                                <h5 className="fw-semibold text-success mb-0">
                                  Loyalty Points
                                </h5>
                                <button className="btn btn-danger">
                                  Remove
                                </button>
                              </div>

                              <div className="d-flex flex-column gap-2">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Points:</span>
                                  <span className="fw-medium text-dark">
                                    {item.points}
                                  </span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Value (₹):</span>
                                  <span className="fw-medium text-dark">
                                    ₹{parseFloat(item.value).toFixed(2)}
                                  </span>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">
                                    Created On:
                                  </span>
                                  <span className="fw-medium text-dark">
                                    {item.created_on}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-danger mb-4">
                          No loyalty points found.
                        </div>
                      )}

                      <div className="p-4 bg-light border-0 rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Update Loyalty Points
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-6">
                            <label className="form-label">Loyalty Points</label>
                            <input
                              type="text"
                              className="form-control"
                              name="points"
                              value={updateLoyaltyPointsData.points}
                              onChange={handleLoyaltyPointsChange}
                              placeholder="Enter Loyalty Points"
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">
                              Loyalty Points Value in Rupees
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="value"
                              value={updateLoyaltyPointsData.value}
                              onChange={handleLoyaltyPointsChange}
                              placeholder="Enter Value in ₹"
                            />
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4"
                            onClick={handleUpdateLoyaltyPoints}
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Update Loyalty Points"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Free Item Tab */}
                {activeTab === "free" && (
                  <div className="row">
                    <div className="col-12">
                      <div className="p-4 bg-light border-0 rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Select Free Item
                        </h5>
                        <div className="row">
                          {/* Form Section */}
                          <div className="col-md-5">
                            <div className="bg-white p-4 rounded shadow-sm">
                              <div className="mb-3">
                                <label className="form-label">
                                  Minimum Order Amount
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${!isNumber(freeItemData.minAmount) &&
                                    attemptedSubmit
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  name="minAmount"
                                  value={freeItemData.minAmount}
                                  onChange={handleFreeItemChanges}
                                  placeholder="Enter Minimum Order Amount"
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label">
                                  Customer Type
                                </label>
                                <select
                                  className="form-control"
                                  name="singleUse"
                                  value={freeItemData.singleUse}
                                  onChange={handleFreeItemChanges}
                                >
                                  <option value="Y">
                                    First Time User Only
                                  </option>
                                  <option value="N">For All</option>
                                </select>
                              </div>

                              <div className="mb-3">
                                <label className="form-label">
                                  Selected Free Item
                                </label>
                                {selectedFreeItem?.item_name ? (
                                  <div className="d-flex align-items-center bg-light py-2 rounded">
                                    <div
                                      className="flex-shrink-0"
                                      style={{
                                        width: "5rem",
                                        height: "5rem",
                                        overflow: "hidden",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <img
                                        src={selectedFreeItem.photo}
                                        alt={selectedFreeItem.item_name}
                                        className="w-100 h-100 object-fit-cover"
                                      />
                                    </div>
                                    <div className="ms-3">
                                      <p className="fw-semibold mb-0">
                                        {selectedFreeItem.item_name}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  <p className="text-muted small">
                                    No item selected
                                  </p>
                                )}
                              </div>

                              <button
                                className="btn btn-success w-100 mt-3"
                                onClick={handleSetFreeItems}
                                disabled={loading}
                              >
                                {loading ? "Submitting..." : "Submit"}
                              </button>
                            </div>
                          </div>

                          {/* Item Selection Section */}
                          <div className="col-md-7">
                            <div className="bg-white p-4 rounded shadow-sm">
                              <h5 className="mb-4">
                                Choose a free item from menu
                              </h5>
                              {loading ? (
                                <div className="d-flex justify-content-center my-5">
                                  <div
                                    className="spinner-border text-success"
                                    role="status"
                                  />
                                </div>
                              ) : (
                                <>
                                  {filteredCategories.map((category) => {
                                    const catId = String(category.cat_id);
                                    const isExpanded =
                                      expandedCategories.includes(catId);
                                    const itemsToShow = isExpanded
                                      ? category.menu_items
                                      : [];

                                    return (
                                      <div key={catId}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <p
                                            className="fw-bold text-dark"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              toggleCategory(catId)
                                            }
                                          >

                                            {category.category_name}
                                          </p>
                                          {category.menu_items.length > 1 && (
                                            <button
                                              className="btn btn-sm bg-light text-primary"
                                              onClick={() =>
                                                toggleCategory(catId)
                                              }
                                            >
                                              <img
                                                src={
                                                  isExpanded
                                                    ? downArrow
                                                    : rightArrow
                                                }
                                                style={{
                                                  width: "1rem",
                                                  height: "1rem",
                                                }}
                                                alt="Toggle"
                                              />
                                            </button>
                                          )}
                                        </div>

                                        <div>
                                          {itemsToShow.map((item) => (
                                            <div
                                              key={item.item_id}
                                              className={`d-flex align-items-center p-2 rounded mb-2 cursor-pointer ${selectedFreeItem?.item_id ===
                                                item.item_id
                                                ? "bg-light "
                                                : "bg-light"
                                                }`}
                                            // onClick={() =>
                                            //   setSelectedFreeItem(item)
                                            // }
                                            >
                                              <input
                                                type="radio"
                                                name="selectedFreeItem"
                                                className="form-check-input me-3"
                                                checked={
                                                  selectedFreeItem?.item_id ===
                                                  item.item_id
                                                }
                                                onChange={() =>
                                                  setSelectedFreeItem(item)
                                                } // Optional: covered by parent div
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                } // Prevent parent click when clicking radio
                                              />
                                              <div
                                                className="flex-shrink-0"
                                                style={{
                                                  width: "5rem",
                                                  height: "5rem",
                                                  borderRadius: "10px",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                <img
                                                  src={item.photo}
                                                  alt={item.item_name}
                                                  className="w-100 h-100 object-fit-cover"
                                                />
                                              </div>
                                              <div className="ms-3">
                                                <p className="mb-0 fw-medium">
                                                  {item.item_name}
                                                </p>
                                                <p className="text-muted small mb-0">
                                                  {item.prices.formatted_price}
                                                </p>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                        <hr />
                                      </div>
                                    );
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "orderTiming" && (
                  <div className="row">
                    <div className="col-12">
                      {timingData &&
                        timingData.openingTime &&
                        timingData.closingTime ? (
                        <div className="col">
                          <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                              <h5 className="fw-semibold text-success mb-0">
                                Current Restaurant Time
                              </h5>
                            </div>

                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">
                                  Opening Time:
                                </span>
                                <span className="fw-medium text-dark">
                                  {timingData.openingTime}
                                  {/* {new Date(
                                    `1970-01-01T${timingData.openingTime}Z`
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })} */}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span className="text-muted">
                                  Closing Time:
                                </span>
                                <span className="fw-medium text-dark">
                                  {timingData.closingTime}
                                  {/* {new Date(
                                    `1970-01-01T${timingData.closingTime}Z`
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })} */}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-danger mb-4">
                          No restaurant timing found.
                        </div>
                      )}

                      <div className="p-4 bg-light border-0 rounded-4">
                        <h5 className="fw-semibold text-success mb-4">
                          Update Restaurant Timing
                        </h5>
                        <div className="row g-4">
                          <div className="col-md-2">
                            <label className="form-label">Opening Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="opening"
                              value={updateOrderTimingData.opening}
                              onChange={handleOrderTimingChange}
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Closing Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="closing"
                              value={updateOrderTimingData.closing}
                              onChange={handleOrderTimingChange}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">Week Off</label>
                            <select
                              className="form-select"
                              name="weekOff"
                              value={updateOrderTimingData.weekOff}
                              onChange={handleOrderTimingChange}
                            >
                              <option value="">Select a day</option>
                              <option value="Sunday">Sunday</option>
                              <option value="Monday">Monday</option>
                              <option value="Tuesday">Tuesday</option>
                              <option value="Wednesday">Wednesday</option>
                              <option value="Thursday">Thursday</option>
                              <option value="Friday">Friday</option>
                              <option value="Saturday">Saturday</option>
                              <option value="No_Week_Off">No Week Off</option>

                            </select>
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-success mt-4"
                            onClick={handleUpdateOrderTiming}
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Update Timing"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Receipt Printing Tab */}
                {/* Receipt Printing Tab (NEW - Dynamic) */}
                {activeTab === "printing" && (
                  <div className="row">
                    <div className="col-6">
                      {printLoading ? (
                        <div className="p-4 bg-white w-100 border rounded-4 mb-3 text-center">
                          <div className="spinner-border text-success" role="status" />
                          <div className="mt-2 text-muted">Loading print settings...</div>
                        </div>
                      ) : printSettingDetails?.printSettings?.length ? (
                        <div className="col">
                          <div className="p-4 bg-white w-100 border rounded-4 mb-3">
                            <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                              <h5 className="fw-semibold text-success mb-0">Print Settings</h5> <button
                                className="blue-button single-line-css ms-3"
                                onClick={() => setAddPrinterModalOpen(true)}
                              >
                                Add Printer
                              </button>
                            </div>


                            {/* Your 3 top summary rows (same UX) */}
                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Use Anlook Printing Software:</span>
                                <span className="fw-medium text-dark">
                                  {(printForm?.anlookActive ?? printSettingDetails?.printSettings?.find(p => p.key === "anlookActive")?.value) === "1"
                                    ? "Enabled"
                                    : "Disabled"}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Auto-Print Receipts:</span>
                                <span className="fw-medium text-dark">
                                  {(printForm?.autoPrint ?? printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value) === "1"
                                    ? "Enabled"
                                    : "Disabled"}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between">
                                <span className="text-muted">Receipt Print Mode:</span>
                                <span className="fw-medium text-dark">
                                  {(printForm?.autoPrint ?? printSettingDetails?.printSettings?.find(p => p.key === "autoPrint")?.value) === "1"
                                    ? "Print automatically after payment"
                                    : "Manual print with one click"}
                                </span>
                              </div>

                              <hr />

                              {/* Show ALL keys (read-only) */}
                              {printSettingDetails.printSettings.map((setting, idx) => (
                                <div key={idx} className="d-flex justify-content-between">
                                  <span className="text-muted">{setting.key}:</span>
                                  <span className="fw-medium text-dark">{setting.value}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-danger mb-4">
                          No print setting data found.
                        </div>
                      )}

                      {/* UPDATE CARD (Dynamic Inputs) */}
                      <div className="p-4 bg-light border-0 rounded-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="fw-semibold text-success mb-0">Update Printing Setting</h5>

                          <button
                            className="btn btn-outline-success btn-sm"
                            onClick={getPrintSettingsApi}
                            disabled={printLoading || loading}
                          >
                            Refresh
                          </button>
                        </div>

                        <div className="row g-4">
                          {printConfigs.map((s) => {
                            const hint = printTypeHint[s.key];
                            const value = printForm[s.key] ?? "";

                            // 🔘 SWITCHES
                            if (hint === "01" || hint === "YN") {
                              return (
                                <div className="col-md-12" key={s.key}>
                                  <div className="form-check form-switch mt-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={s.key}
                                      checked={value === "1" || value === "Y"}
                                      onChange={(e) =>
                                        handlePrintDynamicChange(
                                          s.key,
                                          hint === "YN"
                                            ? e.target.checked ? "Y" : "N"
                                            : e.target.checked ? "1" : "0"
                                        )
                                      }
                                    />
                                    <label className="form-check-label" htmlFor={s.key}>
                                      {s.key}
                                    </label>
                                  </div>
                                </div>
                              );
                            }

                            // 🔢 NUMERIC INPUTS (counts)
                            if (hint === "NUMBER") {
                              return (
                                <div className="col-md-12" key={s.key}>
                                  <label className="form-label">{s.key} (Count)</label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    value={value}
                                    onChange={(e) => handlePrintDynamicChange(s.key, e.target.value)}
                                  />
                                </div>
                              );
                            }

                            // ✏️ TEXT INPUTS
                            return (
                              <div className="col-md-12" key={s.key}>
                                <label className="form-label">{s.key}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={value}
                                  onChange={(e) => handlePrintDynamicChange(s.key, e.target.value)}
                                />
                              </div>
                            );
                          })}

                        </div>

                        <div>
                          <button
                            className="btn btn-success mt-4"
                            onClick={handleUpdatePrintSetting}
                            disabled={loading || printLoading}
                          >
                            {loading ? "Updating..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Right Column (unchanged) */}
                    <div className="col-6 d-flex flex-column">
                      <div className="bg-light rounded border p-4 w-100">
                        <h4 className="fw-bold mb-3">Anlook Auto Printing Settings</h4>

                        {/* Checkbox Options */}
                     <div className="d-flex gap-3 mb-1">

  <label>
    <input
      type="radio"
      value="1"
      checked={selectedSetting === "1"}
      onChange={(e) => setSelectedSetting(e.target.value)}
    />
    Default
  </label>

  <label>
    <input
      type="radio"
      value="2"
      checked={selectedSetting === "2"}
      onChange={(e) => setSelectedSetting(e.target.value)}
    />
    Item Wise
  </label>

  <label>
    <input
      type="radio"
      value="3"
      checked={selectedSetting === "3"}
      onChange={(e) => setSelectedSetting(e.target.value)}
    />
    Category Wise
  </label>

</div>

                        {/* Save Button */}
                        <Button
  onClick={savePrinterSetting}
  disabled={loading}
  className="px-4 py-2"
>
  {loading ? "Saving..." : "Save Settings"}
</Button>
                      </div>

                      <div className="card bg-light mt-4 shadow-sm border-0 w-100">
                        <div className="card-body px-4 px-md-5 py-4">
                          <h4 className="fw-bold mb-4 text-primary text-center">
                            Current Printers list
                          </h4>
                          <table className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Printer Name</th>
                                <th>Printer Code</th>
                                <th>Printer Alias</th>
                              </tr>
                            </thead>
                            <tbody>
                              {printerList.map((printer, index) => (
                                <tr key={printer.id}>
                                  <td>{index + 1}</td>
                                  <td>{printer.printerName}</td>
                                  <td>{printer.printerCode}</td>
                                  <td>{printer.printerAlias}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


              </>
            )}
          </div>
        </div>
      </div>
      {/* Add Printer Modal */}
      <AddPrinterModal
        open={addPrinterModalOpen}
        onClose={() => setAddPrinterModalOpen(false)}
        formData={addPrinterFormData}
        onChange={handlePrinterInputChange}
        onSubmit={handleAddPrinterSubmit}
      />
    </>
  );
};

export default OrderSettings;
